const middleware = {}

middleware['invoice-owner'] = require('../middleware/invoice-owner.js')
middleware['invoice-owner'] = middleware['invoice-owner'].default || middleware['invoice-owner']

middleware['redirects'] = require('../middleware/redirects.js')
middleware['redirects'] = middleware['redirects'].default || middleware['redirects']

export default middleware
